class RequestContext {
  public headers: Record<string, any> = {};
}

export default RequestContext;
